(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-body-blocks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function processInstagram() {
      if (!document.querySelector('.instagram-media')) return;

      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
        return;
      }

      if (document.getElementById('polipoli-instagram-embed-js')) return;

      var s = document.createElement('script');
      s.id = 'polipoli-instagram-embed-js';
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      s.onload = function () {
        if (window.instgrm && window.instgrm.Embeds) {
          window.instgrm.Embeds.process();
        }
      };
      document.body.appendChild(s);
    }

    if (document.readyState !== 'loading') {
      processInstagram();
    } else {
      document.addEventListener('DOMContentLoaded', processInstagram);
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.instagram-media')) {
        processInstagram();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-grid-updated"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGrid(root) {
      if (!root || root.dataset.agInit === 'true') return;

      var grid = root.querySelector('[data-article-grid]');
      var button = root.querySelector('[data-article-grid-more]');
      if (!grid) { root.dataset.agInit = 'true'; return; }

      var increment = parseInt(grid.getAttribute('data-increment'), 10);
      if (!increment || increment < 1) increment = 8;

      function hiddenCards() {
        return grid.querySelectorAll('.polipoli-article-grid__card.is-hidden');
      }

      function update() {
        if (!button) return;
        button.hidden = hiddenCards().length === 0;
      }

      function reveal() {
        var cards = hiddenCards();
        var n = Math.min(increment, cards.length);
        for (var i = 0; i < n; i++) {
          cards[i].classList.remove('is-hidden');
        }
        update();
        if (n > 0) {
          var firstNew = cards[0].querySelector('.polipoli-article-grid__title a');
          if (firstNew) firstNew.focus();
        }
      }

      if (button) button.addEventListener('click', reveal);
      update();

      root.dataset.agInit = 'true';
      root._agCleanup = function () {
        if (button) button.removeEventListener('click', reveal);
      };
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-article-grid-root]');
      for (var i = 0; i < roots.length; i++) initGrid(roots[i]);
    }

    function destroy(root) {
      if (root && typeof root._agCleanup === 'function') {
        root._agCleanup();
        root.dataset.agInit = '';
      }
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target.querySelectorAll('[data-article-grid-root]');
      for (var i = 0; i < roots.length; i++) destroy(roots[i]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGrid(root) {
      if (!root || root.dataset.agInit === 'true') return;

      var grid = root.querySelector('[data-article-grid]');
      var button = root.querySelector('[data-article-grid-more]');
      if (!grid) { root.dataset.agInit = 'true'; return; }

      var increment = parseInt(grid.getAttribute('data-increment'), 10);
      if (!increment || increment < 1) increment = 8;

      function hiddenCards() {
        return grid.querySelectorAll('.polipoli-article-grid__card.is-hidden');
      }

      function update() {
        if (!button) return;
        button.hidden = hiddenCards().length === 0;
      }

      function reveal() {
        var cards = hiddenCards();
        var n = Math.min(increment, cards.length);
        for (var i = 0; i < n; i++) {
          cards[i].classList.remove('is-hidden');
        }
        update();
        if (n > 0) {
          var firstNew = cards[0].querySelector('.polipoli-article-grid__title a');
          if (firstNew) firstNew.focus();
        }
      }

      if (button) button.addEventListener('click', reveal);
      update();

      root.dataset.agInit = 'true';
      root._agCleanup = function () {
        if (button) button.removeEventListener('click', reveal);
      };
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-article-grid-root]');
      for (var i = 0; i < roots.length; i++) initGrid(roots[i]);
    }

    function destroy(root) {
      if (root && typeof root._agCleanup === 'function') {
        root._agCleanup();
        root.dataset.agInit = '';
      }
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target.querySelectorAll('[data-article-grid-root]');
      for (var i = 0; i < roots.length; i++) destroy(roots[i]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionSelector = '[data-blog-cat-carousel]';
    var instances = new WeakMap();

    function BlogCategoryCarousel(section) {
      this.section = section;
      this.track = section.querySelector('[data-carousel-track]');
      this.prevButton = section.querySelector('[data-carousel-prev]');
      this.nextButton = section.querySelector('[data-carousel-next]');

      if (!this.track || !this.prevButton || !this.nextButton) {
        return;
      }

      this.onPrevClick = this.scrollPrevious.bind(this);
      this.onNextClick = this.scrollNext.bind(this);
      this.onScroll = this.updateControls.bind(this);
      this.onResize = this.updateControls.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);

      this.prevButton.addEventListener('click', this.onPrevClick);
      this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize);

      this.updateControls();
    }

    BlogCategoryCarousel.prototype.getScrollBehavior = function () {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    };

    BlogCategoryCarousel.prototype.getScrollAmount = function () {
      return this.track.clientWidth;
    };

    BlogCategoryCarousel.prototype.scrollPrevious = function () {
      this.track.scrollBy({
        left: -this.getScrollAmount(),
        behavior: this.getScrollBehavior()
      });
    };

    BlogCategoryCarousel.prototype.scrollNext = function () {
      this.track.scrollBy({
        left: this.getScrollAmount(),
        behavior: this.getScrollBehavior()
      });
    };

    BlogCategoryCarousel.prototype.handleKeydown = function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.scrollPrevious();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.scrollNext();
      }
    };

    BlogCategoryCarousel.prototype.updateControls = function () {
      var maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      var currentScroll = this.track.scrollLeft;
      var atStart = currentScroll <= 1;
      var atEnd = currentScroll >= maxScroll - 1;

      this.prevButton.disabled = atStart;
      this.nextButton.disabled = atEnd;
      this.prevButton.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      this.nextButton.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    BlogCategoryCarousel.prototype.destroy = function () {
      if (!this.track || !this.prevButton || !this.nextButton) {
        return;
      }

      this.prevButton.removeEventListener('click', this.onPrevClick);
      this.nextButton.removeEventListener('click', this.onNextClick);
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.onResize);
    };

    function initCarousels(root) {
      var scope = root || document;
      var sections = scope.matches && scope.matches(sectionSelector)
        ? [scope]
        : Array.prototype.slice.call(scope.querySelectorAll(sectionSelector));

      sections.forEach(function (section) {
        if (!instances.has(section)) {
          instances.set(section, new BlogCategoryCarousel(section));
        }
      });
    }

    function destroyCarousels(root) {
      var scope = root || document;
      var sections = scope.matches && scope.matches(sectionSelector)
        ? [scope]
        : Array.prototype.slice.call(scope.querySelectorAll(sectionSelector));

      sections.forEach(function (section) {
        var instance = instances.get(section);
        if (instance) {
          instance.destroy();
          instances.delete(section);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCarousels(document);
      });
    } else {
      initCarousels(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initCarousels(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.bhInit === 'true') return;

      var viewport = root.querySelector('[data-blog-hero-viewport]');
      var slides = root.querySelectorAll('[data-blog-hero-slide]');
      var prev = root.querySelector('[data-blog-hero-prev]');
      var next = root.querySelector('[data-blog-hero-next]');
      var dots = root.querySelectorAll('[data-blog-hero-dot]');

      if (!viewport || slides.length <= 1) { root.dataset.bhInit = 'true'; return; }

      var loop = root.dataset.loop === 'true';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;

      function go(i) {
        var n = slides.length;
        if (loop) { i = (i % n + n) % n; }
        else { i = Math.max(0, Math.min(n - 1, i)); }
        var w = viewport.clientWidth;
        viewport.scrollTo({ left: w * i, behavior: reduce ? 'auto' : 'smooth' });
      }

      function setActive(i) {
        current = i;
        for (var d = 0; d < dots.length; d++) {
          var on = d === i;
          dots[d].classList.toggle('is-active', on);
          if (on) { dots[d].setAttribute('aria-current', 'true'); }
          else { dots[d].removeAttribute('aria-current'); }
        }
      }

      function onScroll() {
        var w = viewport.clientWidth || 1;
        var i = Math.round(viewport.scrollLeft / w);
        if (i !== current) setActive(i);
      }

      var scrollTimer;
      function scrollHandler() {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(onScroll, 60);
      }
      function prevHandler() { go(current - 1); }
      function nextHandler() { go(current + 1); }
      function keyHandler(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      }

      viewport.addEventListener('scroll', scrollHandler, { passive: true });
      if (prev) prev.addEventListener('click', prevHandler);
      if (next) next.addEventListener('click', nextHandler);
      root.addEventListener('keydown', keyHandler);

      var dotHandlers = [];
      for (var d = 0; d < dots.length; d++) {
        (function (idx) {
          var h = function () { go(idx); };
          dotHandlers.push(h);
          dots[idx].addEventListener('click', h);
        })(d);
      }

      root._bhCleanup = function () {
        viewport.removeEventListener('scroll', scrollHandler);
        if (prev) prev.removeEventListener('click', prevHandler);
        if (next) next.removeEventListener('click', nextHandler);
        root.removeEventListener('keydown', keyHandler);
        for (var k = 0; k < dots.length; k++) {
          dots[k].removeEventListener('click', dotHandlers[k]);
        }
      };

      root.dataset.bhInit = 'true';
      setActive(0);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-blog-hero-carousel]');
      for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
    }

    function destroy(root) {
      if (root && typeof root._bhCleanup === 'function') {
        root._bhCleanup();
        root.dataset.bhInit = '';
      }
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target.querySelectorAll('[data-blog-hero-carousel]');
      for (var i = 0; i < roots.length; i++) destroy(roots[i]);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
